/* eslint-disable */
import TabsLayout from "components/general/TabsLayout";
import { ShiftType, ShiftTypeName } from "constants/ShiftType";
import useGetUserInfo from "hooks/useGetUserInfo";
import {
  useGetShiftsStatisticsQuery,
  useGetStaffShiftsStatisticsQuery,
} from "apis/services/shift";
import BulkUploadLog from "components/pages/shifts/BulkUploadLog";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import Fixed from "../../components/pages/shifts/Fixed";
import BasedSetup from "../../components/pages/shifts/BasedSetup";
import Flexible from "../../components/pages/shifts/Flexible";
import styles from "./styles.module.scss";
import usePermissions from "hooks/usePermission";
import { PermissionCodename } from "constants/permission";
import filterByPermissions from "utils/filterByPermissions";

type ShiftTab = {
  label: string;
  key: string;
  children: React.ReactNode;
  permission?: PermissionCodename;
};

export default function Shifts() {
  const [searchParams] = useSearchParams();
  const { hasPermissionTo } = usePermissions();
  const viewStatistics = hasPermissionTo("view_statistics");

  // @ts-ignore
  const { data: statistics, isLoading: isStatisticLoading } = useGetStaffShiftsStatisticsQuery({
    start_date:
      searchParams.get("startDate") ?? moment(new Date()).format("YYYY-MM-DD"),
    end_date:
      searchParams.get("endDate") ??
      moment(new Date()).add(1, "day").format("YYYY-MM-DD"),
  },
    {
      skip: !viewStatistics,
    });


  const shiftTabs: ShiftTab[] = [
    {
      label: ShiftTypeName[ShiftType.Fixed],
      key: ShiftType.Fixed.toString(),
      children: (
        <Fixed statisticts={statistics} viewStatistics={viewStatistics} isLoading={isStatisticLoading} />
      ),
    },
    {
      label: ShiftTypeName[ShiftType.Based],
      key: ShiftType.Based.toString(),
      children: (
        <BasedSetup statisticts={statistics} viewStatistics={viewStatistics} isLoading={isStatisticLoading} />
      ),
    },
    {
      label: ShiftTypeName[ShiftType.Flexible],
      key: ShiftType.Flexible.toString(),
      children: (
        <Flexible statisticts={statistics} viewStatistics={viewStatistics} isLoading={isStatisticLoading} />
      ),
    },
    {
      label: "Bulk Upload Log",
      key: "logs",
      permission: "view_shift_bulk_upload_log",
      children: (
        <BulkUploadLog
          statisticts={statistics}
          isLoading={isStatisticLoading}
        />
      ),
    },
  ];

  const filteredTabs = filterByPermissions(shiftTabs, hasPermissionTo);

  return (
    <div className={styles.container}>
      <TabsLayout tabs={filteredTabs} />
    </div>
  );
}
